"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var identify = function identify(options) {
  if (typeof (window || {}).analytics === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('Analytics not loaded - identify event not completed');
    return false;
  }

  try {
    window.analytics.identify(options.userId, {
      firstName: options.firstName,
      lastName: options.lastName,
      email: options.email
    });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('Error sending identify analytics:', error);
    }
  }

  return true;
};

var _default = identify;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/identify.js
// module id = 1833
// module chunks = 25